import { STATS_ROW } from '../data/features.js'

export default function StatsRow() {
  return (
    <section className="py-16 bg-kart-blue text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {STATS_ROW.map(stat => (
            <div key={stat.label}>
              <div className="font-display font-semibold text-5xl mb-2">{stat.value}</div>
              <div className="text-blue-200 text-lg">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
